export default "__VITE_ASSET__DhWXKF5h__";